import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";

export default function UpdatesPage() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const copilotWidget = document.querySelector('#emergent-copilot, [data-emergent-copilot], .emergent-chat-widget');
    if (copilotWidget) copilotWidget.style.display = 'none';
    
    fetchPage();
    
    return () => {
      if (copilotWidget) copilotWidget.style.display = '';
    };
  }, []);

  const fetchPage = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/pages/public/updates`);
      const data = await res.json();
      setPageData(data);
    } catch (e) {
      console.error("Failed to load page:", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center">
        <div className="text-zinc-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex flex-col">
      <div className="container mx-auto px-6 py-12 max-w-4xl flex-1">
        <style>{`
          .page-content { color: white; }
          .page-content h1 { color: white; font-size: 2.5rem; margin-bottom: 1.5rem; font-weight: bold; }
          .page-content h2 { color: #f3f4f6; font-size: 2rem; margin-bottom: 1rem; font-weight: 600; }
          .page-content p { color: #e5e7eb; font-size: 1.125rem; line-height: 1.75; margin-bottom: 1rem; }
          .page-content a { color: #3b82f6; text-decoration: underline; }
        `}</style>
        <div 
          className="page-content"
          dangerouslySetInnerHTML={{ __html: pageData?.content || "<h1>Updates</h1><p>Content coming soon...</p>" }}
        />
      </div>
      <Footer />
    </div>
  );
}
